import Api from "shared/service/api/api";

// actions
export const LOAD_COUPONS = "loadCoupons";
export const CHANGE_COUPON_STATUS = "changeCouponStatus";
export const CREATE_COUPON = "createCoupon";

//mutations
export const SET_COUPONS = "setCoupons";

const state = {
  coupons: {
    list: [],
    page: 1,
    page_count: 1,
  },
  datasets: {
    couponTypes: [
      { id: 1, name: "Одноразовый" },
      { id: 2, name: "Многоразовый" },
    ],
  },
};

const actions = {
  [LOAD_COUPONS]({ commit }, { page, code = null, item_id = null }) {
    Api.coupon
      .all(page, code, item_id)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(SET_COUPONS, response.data);
      })
      .catch((e) => e);
  },
  [CHANGE_COUPON_STATUS]({ state }, { coupon_id }) {
    let coupon = state.coupons.list.find((element) => element.id === coupon_id);

    return Api.coupon.updateStatus(coupon_id, coupon.status ? 0 : 1).catch((e) => e);
  },
  [CREATE_COUPON]() {
    return new Promise((resolve) => {
      Api.coupon
        .create()
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          resolve(response.data.id);
        })
        .catch(() => {
          resolve(undefined);
        });
    });
  },
};

const mutations = {
  [SET_COUPONS](state, { list, page, page_count }) {
    state.coupons.list = list;
    state.coupons.page = page;
    state.coupons.page_count = page_count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
